/**
 * Output html from various sources
 * <div ng-bind-html="html_variable | trust"></div>
 */

const $trust = ['$sce', function($sce) {
    return function(htmlCode){
        if ( typeof htmlCode !== "string") {
            htmlCode = "";
        }
        return $sce.trustAsHtml(htmlCode);
    }
}];

export default $trust;
